import { useState } from 'react';

export const useLocalStorage = (keyName: string, defaultValue: any): any => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);

      if (value) {
        return JSON.parse(value);
      } 
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      
    } catch {
      return defaultValue;
    }
  });

  const setValue = (newValue: any) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    // eslint-disable-next-line no-empty
    } catch {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};

export default useLocalStorage;

